import React, { useContext, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { Swarm } from '@lbs/swarm-client';
import Config from '@skin_config';
import { ascSort } from '@common/helpers/declarative/sortings';
import Dropdown from '@common/components/dropdown';

import Helpers from '@common/helpers/helperFunctions';
import { PreferencesContext } from '@common/contexts/preferences';
import { SetLanguage } from '@app/dev/actions/terminal';
import { checkTerminalMode, normalizeAlias } from '@common/helpers';
import { changeDateLocale } from '@common/helpers/dateLocale';

import './style.scss';

const LanguageSwitcher = ({ showFlag }) => {
  const dispatch = useDispatch();
  const [preferences, setPreferences] = useContext(PreferencesContext);

  const selectOptions = useMemo(() => (
    Helpers
      .objectToArray(Config.main.availableLanguages, 'code')
      .sort(ascSort('order'))
      .map((item) => ({
        name: showFlag ? (
          <>
            <span className={`flag icon-${normalizeAlias(item.region)}`} />
            {item.name}
          </>
        ) : item.name,
        value: item.code,
      }))
  ), [showFlag]);

  const changeLanguage = ({ value }) => {
    const lang = Config.swarm.languageMap[value] || value;

    if (checkTerminalMode(Config, 'betting')) {
      Swarm.getInstance().changeLanguage(lang);
    }

    setPreferences({ ...preferences, lang: value });
    dispatch(SetLanguage(lang));
    changeDateLocale(lang);
  };

  return (
    selectOptions.length > 1 ? (
      <div className="language-switcher-holder">
        <Dropdown
          value={preferences.lang}
          options={selectOptions}
          className="language-switcher"
          onChange={changeLanguage}
        />
      </div>
    )
      : (
        <div className="language-holder">
            {selectOptions[0].name}
        </div>
      )

  );
};

LanguageSwitcher.propTypes = {
  user: PropTypes.object,
  showFlag: PropTypes.bool,
  isOpenedLanguages: PropTypes.any,
  isOpenedSettingSportsBook: PropTypes.any,
};

export default LanguageSwitcher;
